import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import { EntityNotificationTypes } from '@/_types/entities';

export const getNotificationTypes = async ({
  token,
  entityId,
}: APIRequest<{
  entityId: number;
}>): APIResponsePromise<EntityNotificationTypes> =>
  await _callBackend(
    `/companies/${entityId}/get_notification_type_ids`,
    'GET',
    null,
    token,
  );

export const saveNotificationPreference = async ({
  token,
  entityIds,
  notificationTypeIds,
}: APIRequest<{
  entityIds: Array<number>;
  notificationTypeIds: EntityNotificationTypes;
}>): APIResponsePromise =>
  await _callBackend(
    '/companies/save_notification_subscription',
    'POST',
    {
      entity_ids: entityIds,
      notification_type_ids: notificationTypeIds,
    },
    token,
  );
